/* eslint sonarjs/no-duplicate-string: 0 */
export const logos = {
  'telenet-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-yellow.svg',
    mobile: '../assets/shared/logos/telenet/telenet-yellow.svg',
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-yellow-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-yellow-tabasco.svg',
    mobile: '../assets/shared/logos/telenet/telenet-yellow-tabasco.svg',
    category: 'telenet',
    alt: 'logo telenet tabasco',
  },
  'telenet-yellow-accent-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-yellow-accent-tabasco.svg',
    mobile: '../assets/shared/logos/telenet/telenet-yellow-accent-tabasco.svg',
    category: 'telenet',
    alt: 'logo telenet tabasco',
  },
  'telenet-white': {
    desktop: '../assets/shared/logos/telenet/telenet-white.svg',
    mobile: '../assets/shared/logos/telenet/telenet-white.svg',
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-white-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-white-tabasco.svg',
    mobile: '../assets/shared/logos/telenet/telenet-white-tabasco.svg',
    category: 'telenet',
    alt: 'logo telenet tabasco',
  },
  'telenet-black': {
    desktop: '../assets/shared/logos/telenet/telenet-black.svg',
    mobile: '../assets/shared/logos/telenet/telenet-black.svg',
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-black-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-black-tabasco.svg',
    mobile: '../assets/shared/logos/telenet/telenet-black-tabasco.svg',
    category: 'telenet',
    alt: 'logo telenet tabasco',
  },
  'telenet-color': {
    desktop: '../assets/shared/logos/telenet/telenet-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-color': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-white': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-yellow-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-yellow-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-color-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-color-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-white-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-white-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-yellow-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-yellow-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-color-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-color-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-brussels-white-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-brussels-white-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet',
  },
  'telenet-business-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-business-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-color': {
    desktop: '../assets/shared/logos/telenet/telenet-business-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-white': {
    desktop: '../assets/shared/logos/telenet/telenet-business-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-yellow-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-business-yellow-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-color-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-business-color-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-white-sm': {
    desktop: '../assets/shared/logos/telenet/telenet-business-white-sm.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-yellow-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-yellow-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-color-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-color-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-white-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-white-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business ',
  },
  'telenet-business-solid-white-tabasco-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-solid-white-tabasco-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-solid-black-tabasco-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-solid-black-tabasco-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-brussels-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-brussels-color': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-brussels-white': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business ',
  },
  'telenet-business-brussels-yellow-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-yellow-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-brussels-color-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-color-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business',
  },
  'telenet-business-brussels-white-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-business-brussels-white-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business ',
  },
  'telenet-business-partner-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-business-partner-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business partner',
  },
  'telenet-business-partner-color': {
    desktop: '../assets/shared/logos/telenet/telenet-business-partner-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business partner',
  },
  'telenet-business-partner-white': {
    desktop: '../assets/shared/logos/telenet/telenet-business-partner-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet business partner ',
  },
  'telenet-genius-logo': {
    desktop: '../assets/shared/logos/telenet/telenet-genius-logo.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet genius',
  },
  'telenet-netweters-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweter',
  },
  'telenet-netweters-color': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-color.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweters',
  },
  'telenet-netweters-white': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweters ',
  },
  'telenet-netweters-yellow-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-yellow-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweters',
  },
  'telenet-netweters-color-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-color-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweters',
  },
  'telenet-netweters-white-vertical': {
    desktop: '../assets/shared/logos/telenet/telenet-netweters-white-vertical.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo de netweters ',
  },
  'telenet-tv-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv',
  },
  'telenet-tv-flow-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-flow-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv flow',
  },
  'telenet-tv-flow-white': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-flow-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv flow ',
  },
  'telenet-tv-iconic-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-iconic-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv iconic',
  },
  'telenet-tv-iconic-white': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-iconic-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv iconic ',
  },
  'telenet-tv-yellow-yellow': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-yelo-yellow.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv yellow',
  },
  'telenet-tv-yellow-white': {
    desktop: '../assets/shared/logos/telenet/telenet-tv-yelo-white.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet-tv yellow ',
  },
  'telenet-corporate-black-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-corporate-black-tabasco.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet corporate',
  },
  'telenet-corporate-white-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-corporate-white-tabasco.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet corporate ',
  },
  'telenet-corporate-on-brand-tabasco': {
    desktop: '../assets/shared/logos/telenet/telenet-corporate-on-brand-tabasco.svg',
    mobile: null,
    category: 'telenet',
    alt: 'logo telenet corporate',
  },
  base: {
    desktop: '../assets/shared/logos/base/base.svg',
    mobile: null,
    category: 'base',
    alt: 'logo base',
  },
  'base-white': {
    desktop: '../assets/shared/logos/base/base-white.svg',
    mobile: null,
    category: 'base',
    alt: 'logo base',
  },
  'base-alt': {
    desktop: '../assets/shared/logos/base/base-alt.svg',
    mobile: null,
    category: 'base',
    alt: 'logo base',
  },
  'base-alt-white': {
    desktop: '../assets/shared/logos/base/base-alt-white.svg',
    mobile: null,
    category: 'base',
    alt: 'logo base',
  },
  goplay: {
    desktop: '../assets/shared/logos/entertainment-play/goplay.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo goplay',
  },
  play4: {
    desktop: '../assets/shared/logos/entertainment-play/play4.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo play4',
  },
  play5: {
    desktop: '../assets/shared/logos/entertainment-play/play5.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo play5',
  },
  play6: {
    desktop: '../assets/shared/logos/entertainment-play/play6.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo play6',
  },
  play7: {
    desktop: '../assets/shared/logos/entertainment-play/play7.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo play7',
  },
  'playmore-light': {
    desktop: '../assets/shared/logos/entertainment-play/playmore-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playmore',
  },
  playmore: {
    desktop: '../assets/shared/logos/entertainment-play/playmore.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playmore',
  },
  'playmore-telenet-light': {
    desktop: '../assets/shared/logos/entertainment-play/playmore-telenet-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playmore + telenet',
  },
  'playmore-telenet': {
    desktop: '../assets/shared/logos/entertainment-play/playmore-telenet.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playmore + telenet',
  },
  'playsports-light': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  playsports: {
    desktop: '../assets/shared/logos/entertainment-play/playsports.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-light-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-light-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsports.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-telenet-light': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-telenet-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-telenet': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-telenet.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-telenet-light-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-telenet-light-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet',
  },
  'playsports-telenet-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsports-telenet-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsports + telenet ',
  },
  'playsportsopen-light': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen',
  },
  playsportsopen: {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen',
  },
  'playsportsopen-light-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-light-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen',
  },
  'playsportsopen-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen + telenet',
  },
  'playsportsopen-telenet-light': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-telenet-light.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen + telenet',
  },
  'playsportsopen-telenet': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-telenet.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen + telenet',
  },
  'playsportsopen-telenet-light-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-telenet-light-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen + telenet',
  },
  'playsportsopen-telenet-sm': {
    desktop: '../assets/shared/logos/entertainment-play/playsportsopen-telenet-sm.svg',
    mobile: null,
    category: 'entertainment-play',
    alt: 'logo playsportsopen + telenet',
  },
  netflix: {
    desktop: '../assets/shared/logos/entertainment-streaming/netflix.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo netflix',
  },
  primevideo: {
    desktop: '../assets/shared/logos/entertainment-streaming/primevideo.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo primevideo',
  },
  'primevideo-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/primevideo-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo primevideo',
  },
  'primevideo-black': {
    desktop: '../assets/shared/logos/entertainment-streaming/primevideo-black.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo primevideo',
  },
  streamz: {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz',
  },
  'streamz-sm': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-sm.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz',
  },
  'streamz-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz',
  },
  'streamz-white-sm': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-white-sm.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz',
  },
  'streamz+': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz+.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz plus',
  },
  'streamz+-sm': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz+-sm.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz plus',
  },
  'streamz+-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz+-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz plus',
  },
  'streamz+-white-sm': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz+-white-sm.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz plus',
  },
  'streamz-basic': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-basic.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz basic',
  },
  'streamz-basic-vertical': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-basic-vertical.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz basic',
  },
  'streamz-basic-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-basic-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz basic ',
  },
  'streamz-basic-vertical-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-basic-vertical-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz basic',
  },
  'streamz-premium': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium',
  },
  'streamz-premium-vertical': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-vertical.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium',
  },
  'streamz-premium-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium',
  },
  'streamz-premium-vertical-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-vertical-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium',
  },
  'streamz-premium-plus': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-plus.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium-plus',
  },
  'streamz-premium-plus-vertical': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-plus-vertical.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium-plus',
  },
  'streamz-premium-plus-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-plus-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium-plus',
  },
  'streamz-premium-plus-vertical-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/streamz-premium-plus-vertical-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo streamz premium-plus',
  },
  hbo: {
    desktop: '../assets/shared/logos/entertainment-streaming/hbo.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo hbo',
  },
  'hbo-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/hbo-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo hbo',
  },
  'disney+': {
    desktop: '../assets/shared/logos/entertainment-streaming/disney+.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo disney+',
  },
  'disney+-white': {
    desktop: '../assets/shared/logos/entertainment-streaming/disney+-white.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo disney+',
  },
  'disney+-white-gradient': {
    desktop: '../assets/shared/logos/entertainment-streaming/disney+-white-gradient.svg',
    mobile: null,
    category: 'entertainment-streaming',
    alt: 'logo disney+',
  },
};
